export const PROVIDERS = {
  facebook: 'facebook',
  instagram: 'instagram',
  youtube: 'youtube',
  google: 'google',
  google_analytics: 'google_analytics_4',
};
